<div class="chart-container {{ donutChartConfig }}">
  <div class="donut-chart"
       #chart></div>
</div>
